import * as React from 'react'

function SvgNg(props) {
	return (
		<svg viewBox="0 0 6 3" width="1em" height="1em" {...props}>
			<path fill="#008751" d="M0 0h6v3H0z" />
			<path fill="#FFF" d="M2 0h2v3H2z" />
		</svg>
	)
}

export default SvgNg
